import {Component, OnChanges, SimpleChanges, OnInit, Inject} from '@angular/core';
import {Config} from '../../../models/config';
import {FormGroup} from '@angular/forms';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-check-box',
  templateUrl: './form-check-box.component.html',
  styleUrls: ['./form-check-box.component.scss']
})
export class FormCheckBoxComponent  implements OnChanges, OnInit {
  config: Config;
  group: FormGroup;
  isDescription = false;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {
    if (this.group.get(this.config.controlName[0]).value === 'false') {
      this.group.get(this.config.controlName[0]).setValue(false);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
  displayDescription(value: boolean): void {
    this.isDescription = value;
  }
  checkValidity(): boolean {
    if (this.group && this.config) {
      this.group.get([this.config.controlName[0]]).valueChanges.subscribe(val => {
        if (val &&
          (val.toString().toLowerCase() === 'false' || val.toString().toLowerCase() === 'true') &&
          typeof  val !== 'boolean') {
          this.group.get([this.config.controlName[0]]).setValue(JSON.parse(val))
        }
      })
    }
    if (this.group.disabled) {
      return this.group.disabled;
    }
    if (this.config.presentation === 'detail') {
      return true;
    }
  }

}
